<span class="leyenda">©20924. Todos los derechos reservados CNC Dental. </span>
<img class="logo" src="assets/images/logo_neda.svg">

